<template>
  <!-- Era um botão que alternava entre dois idiomas mostrando "en"/"pt" — sem
       dizer o que acontece ao clicar, e sem lembrar da escolha depois do F5.
       O `<v-select>` com os nomes por extenso já estava escrito logo abaixo,
       comentado; virou este menu, que cabe na barra e diz o que oferece. -->
  <v-menu location="bottom end">
    <template v-slot:activator="{ props }">
      <v-btn variant="text" v-bind="props" :aria-label="$t('idioma')">
        <v-icon start size="small">mdi-translate</v-icon>
        {{ atual.curto }}
      </v-btn>
    </template>

    <v-list density="compact" min-width="160">
      <v-list-item
        v-for="idioma in idiomas"
        :key="idioma.valor"
        :active="idioma.valor === $i18n.locale"
        @click="trocar(idioma.valor)"
      >
        <v-list-item-title>{{ idioma.rotulo }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { IDIOMAS, salvarLocale } from "@/i18n";

export default {
  name: "locale-changer",
  data: () => ({ idiomas: IDIOMAS }),
  computed: {
    atual() {
      return (
        this.idiomas.find(i => i.valor === this.$i18n.locale) || this.idiomas[0]
      );
    }
  },
  methods: {
    trocar(valor) {
      this.$i18n.locale = valor;
      salvarLocale(valor);
    }
  }
};
</script>
